import { Routes } from '@angular/router';
import { AuthGuard } from '@guards/auth/auth.guard';
import { ConfirmClearCartGuard } from '@guards/confirm-clear-cart/confirm-clear-cart.guard';
import { ErrorGuard } from '@guards/error/error.guard';
import { SessionExpireGuard } from '@guards/session-expire/session-expire.guard';
import { PageNotFoundComponent } from '@shared-components/error/page-not-found/page-not-found.component';
import { DashboardResolverService } from '@shared/resolvers/dashboard/dashboard.resolver';
import { activity_type_routes } from './activity-type.routes';
import { auth_routes } from './auth.routes';
import { dashboard_routes } from './dashboard.routes';
import { order_summary_routes } from './order-summary.routes';

export const appRoutes: Routes = [
  {
    path: 'auth',
    canActivate: [SessionExpireGuard],
    loadChildren: () => auth_routes
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    loadChildren: () => dashboard_routes,
    resolve: { data: DashboardResolverService }
  },
  {
    path: 'shop',
    canActivate: [AuthGuard],
    children: activity_type_routes,
    canDeactivate: [ConfirmClearCartGuard]
  },
  {
    path: 'order-summary',
    canActivate: [AuthGuard],
    loadChildren: () => order_summary_routes
  },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: '**',
    canActivate: [ErrorGuard],
    component: PageNotFoundComponent
  }
];
